<template>
  <div>
    <v-dialog v-model="showReportDialog">
      <report-viewer v-if="showReportDialog"
        :reportName="Report_Name"
        :dataUrl="Report_URL"
        ref="reportViewer"
        :printOnly="true"
      />   
    </v-dialog>      
       
    <v-dialog v-model="showLeasesDialog" width="500px">
      <v-card>
        <v-card-title>
          <h2>Dog's leases:</h2>
        </v-card-title>
        <v-card-text>
          <div v-if="!!leases && leases.length > 0">
            <div v-for="lease in leases" v-bind:key="lease.leaseId">
              <v-divider horizontal></v-divider>
              <div class="pt-3 pb-3 pr-3 pl-3">
                <h3 :class="!lease.isValid ? 'red--text' : ''">
                  <b>ID #{{ lease.leaseId }}: </b>
                  <span
                    >{{ $dateUtils.formatDate(new Date(lease.startDate)) }} -
                    {{ $dateUtils.formatDate(new Date(lease.endDate)) }}</span
                  ><br />
                </h3>
                <span v-if="!lease.isValid" class="red--text">Cancelled</span>
                <CoownersList
                  :owners="lease.lesees"
                  :ownershipType="leaseOwnershipType"
                />
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <div class="profile-content">
      <h1>Dog Info</h1>
      <v-card class="user-profile-card">
        <v-card-title>
          <v-row>
            <v-col cols="1">              
              <v-avatar size="56">
                <img
                  alt="dog"
                  :src="defaultImage"
                />
              </v-avatar>
            </v-col>
            <v-col cols="8">
              <h4>{{dogInfo.dogPrefix}}</h4>
              <h2>{{ dogInfo.name }}</h2>
              <h4>{{dogInfo.dogSuffix}}</h4>
            </v-col>
            <v-col cols="3">
              <div class="d-flex flex-column">
                  <v-btn class="ma-1" color="secondary" v-if="dogInfo.currentUserIsCoowner" v-on:click="showRegCard()">Registration Card</v-btn>        
                  <v-btn class="ma-1" color="secondary" v-if="dogInfo.digitalPedigreeAccessEnabled" v-on:click="showPedigreeReport()">Show Pedigree</v-btn> 
                <router-link
                    :to="`/profile/pedigrees/${dogInfo.dogId?.trim()}`"                    
                  >
                  <v-btn class="ma-1" color="secondary">      
                    Reports & Pedigrees List
                  </v-btn>
                </router-link>  
                <router-link
                    :to="`/pedigree/order/${dogInfo.dogId?.trim()}?dogName=${dogInfo.name}`"                    
                  >
                  <v-btn class="ma-1" color="secondary">      
                    {{ dogInfo.digitalPedigreeAccessEnabled ? 'Order report or pedigree print': 'Order report or pedigree'}}
                  </v-btn>
                </router-link>                       
              </div>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-divider class="my-3"></v-divider>
          <v-row>
            <v-col cols="12" sm="6">
              <p>
                <b>Dog ID: </b> {{ dogInfo.dogId }} <br />                
                <span v-if="dogInfo.currentUserIsCoowner"><b>CHIP #: </b> {{ dogInfo.chipNumber }}<br /></span>
                <span v-if="dogInfo.currentUserIsCoowner"></span><b>Call name: </b> {{ dogInfo.callName }} <br /></span>
                <b>Gender: </b> {{ dogInfo.gender }} <br />
                <b>Age: </b> {{ dogInfo.age }} Years Old <br />
                <b>Birthdate: </b>
                <span v-if="!!dogInfo.birthdate">{{
                  $dateUtils.formatDate(new Date(dogInfo.birthdate))
                }}</span
                ><span v-else>Unknown</span> <br />
                <b>Body: </b>
                <span v-if="!!dogInfo.body">{{ dogInfo.body }} </span
                ><span v-else>Unknown</span><br />
                <b>Trim: </b>
                <span v-if="!!dogInfo.trim">{{ dogInfo.trim }} </span
                ><span v-else>Unknown</span><br />
                <b>Eyes: </b> {{ dogInfo.eyes }} <br />
                <span v-if="dogInfo.currentUserIsCoowner"><b>DNA Status: </b> {{ dogInfo.dnaStatus }} <br /></span>
                <b>Sire: </b>
                <span v-if="!!dogInfo.sire">{{ dogInfo.sire }} </span
                ><span v-else>Unknown</span><br />
                <b>Dam: </b> <span v-if="!!dogInfo.dam">{{ dogInfo.dam }} </span
                ><span v-else>Unknown</span><br />
                <CoownersList
                  :owners="dogInfo.owners"
                  :ownershipType="dogOwnershipType"
                />
              </p>
            </v-col>
            <v-col cols="12" sm="6">
              <v-row class="ma-0">
                <v-spacer></v-spacer>
                <v-btn
                  v-if="dogInfo.currentUserIsCoowner && leases.length > 0"
                  light
                  large
                  v-on:click="showLeasesDialog = !showLeasesDialog"
                  color="normal"
                  width="135px"
                  class="mr-5"
                  >Show leases</v-btn
                >
              </v-row>
              <v-row class="ma-0 float-end">   
              <div>               
                <div>
                <router-link
                  v-if="dogInfo.canRegisterLitter"
                  class="no-text-decoration"
                  :to="`/registration/litter/${dogInfo.dogId}`"
                >
                  <v-btn
                    light
                    large
                    color="normal"
                    width="135px"
                    class="mr-5 mt-5 float-end"
                    v-if="dogInfo.canRegisterLitter"
                  >
                    Register Litter
                  </v-btn>
                </router-link>
                <router-link
                  class="no-text-decoration"
                  :to="`/leaserequest/${dogInfo.dogId}`"
                >
                  <v-btn
                    light
                    large
                    color="normal"
                    width="135px"
                    class="mr-5 mt-5 float-end"
                    v-if="dogInfo.canRegisterLease"
                  >
                    Add Lease
                  </v-btn>             
                </router-link>
                </div><br>
              </div>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card class="user-profile-card">
        <v-card-title>
          <h3>Titles</h3>
        </v-card-title>
        <v-card-text>
          <v-tooltip v-for="(title, idx) in dogInfo.dogCerts" :key="idx" bottom>
            <template v-slot:activator="{ on, attrs }">
              <span class="fa-layers award mt-7 mb-7" v-bind="attrs" v-on="on">
                <font-awesome-icon size="3x" icon="award" />
                <span class="fa-layers-text award-text">{{ title.title }}</span>
                <br />
                  <a v-if="dogInfo.currentUserIsCoowner" v-on:click="showTitle(title)">Reprint</a>                
              </span>
            </template>
            <span>
              <span>{{ title.description }}</span
              ><br />
              <span>Awarded: {{ $dateUtils.formatDate(title.showDate) }}</span>
            </span>
          </v-tooltip>
        </v-card-text>
      </v-card>
      <v-row>
        <v-col cols="12" sm="4" v-if="
              !!dogInfo &&
              !!dogInfo.pointsSummary &&
              dogInfo.pointsSummary.regular +
                dogInfo.pointsSummary.gambler +
                dogInfo.pointsSummary.jumper >
                0
            ">
          <v-card class="user-profile-card" >
            <v-card-title>
              Working on {{dogInfo.pointsSummary.atchTitle}}
            </v-card-title>
            <v-card-text>
              <span>Regular:</span><br />
              <h1>{{ dogInfo.pointsSummary.regular }}</h1>
              <br />
              <span>Gamblers:</span><br />
              <h1>{{ dogInfo.pointsSummary.gambler }}</h1>
              <br />
              <span>Jumpers:</span><br />
              <h1>{{ dogInfo.pointsSummary.jumper }}</h1>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="4" v-if="
              !!dogInfo &&
              !!dogInfo.pointsSummary &&
              dogInfo.pointsSummary.regularACE +
                dogInfo.pointsSummary.gamblerACE +
                dogInfo.pointsSummary.jumperACE >
                0
            ">
          <v-card class="user-profile-card" >
            <v-card-title>
              Working on {{dogInfo.pointsSummary.aceTitle}}
            </v-card-title>
            <v-card-text>
              <span>Regular:</span><br />
              <h1>{{ dogInfo.pointsSummary.regularACE }}</h1>
              <br />
              <span>Gamblers:</span><br />
              <h1>{{ dogInfo.pointsSummary.gamblerACE }}</h1>
              <br />
              <span>Jumpers:</span><br />
              <h1>{{ dogInfo.pointsSummary.jumperACE }}</h1>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="4" v-if="
              !!dogInfo &&
              !!dogInfo.pointsSummary &&
              !!dogInfo.pointsSummary.otch
              && dogInfo.pointsSummary.otch.totalPoints > 0
            ">
          <v-card class="user-profile-card" >
            <v-card-title>
              Working on {{ dogInfo.pointsSummary.otch.title}}    
            </v-card-title>
            <v-card-text>
              <span>Total points:</span><br />
              <h1>{{ dogInfo.pointsSummary.otch.totalPoints }}</h1>
              <br />
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="4" v-if="
              !!dogInfo &&
              !!dogInfo.pointsSummary &&
              !!dogInfo.pointsSummary.otcH_O
              && dogInfo.pointsSummary.otcH_O.totalPoints > 0
            ">
          <v-card class="user-profile-card" >
            <v-card-title>
              Working on {{ dogInfo.pointsSummary.otcH_O.title}}    
            </v-card-title>
            <v-card-text>
              <span>Total points:</span><br />
              <h1>{{ dogInfo.pointsSummary.otcH_O.totalPoints }}</h1>
              <br />
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="4" v-if="
              !!dogInfo &&
              !!dogInfo.pointsSummary && !!dogInfo.pointsSummary.rtch 
              && !!dogInfo.pointsSummary.rtch.excellentTotalPoints + dogInfo.pointsSummary.rtch.masterTotalPoints > 0">
          <v-card class="user-profile-card">
            <v-card-title>
              Working on {{ dogInfo.pointsSummary.rtch.title}}              
            </v-card-title>
            <v-card-text>
              <span>RTCH Excellent:</span><br />
              <h1>{{ dogInfo.pointsSummary.rtch.excellentTotalPoints }}</h1>
              {{ dogInfo.pointsSummary.rtch.excellent195ScoresCount }} scores >=195  from
                    {{ dogInfo.pointsSummary.rtch.excellent195ScoresJudgesCount }} judges
              <br /><br />
              <span>RTCH Masters:</span><br />
              <h1>{{ dogInfo.pointsSummary.rtch.masterTotalPoints }}</h1>
              {{ dogInfo.pointsSummary.rtch.master195ScoresCount }} scores >=195  from
                    {{ dogInfo.pointsSummary.rtch.master195ScoresJudgesCount }} judges
              <br />
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="4" v-if="!!dogInfo && !!dogInfo.pointsSummary && !!dogInfo.pointsSummary.scch">
          <v-card class="user-profile-card">
            <v-card-title>
              Working on {{ dogInfo.pointsSummary.scch.nextTitle}}                   
            </v-card-title>
            <v-card-text>
              <p>
                <span><b>Points total: </b>{{dogInfo.pointsSummary.scch.pointsTotal}}
                <br/>({{dogInfo.pointsSummary.scch.majorWinsCount}} <b>major wins</b> from {{dogInfo.pointsSummary.scch.majorWinsJudgesCount}} <b>different judges</b> 
                <br/>and remaining scores from {{dogInfo.pointsSummary.scch.otherScoresJudgesCount}} <b>other judges</b>)</span><br/>                                                            
              </p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      
      <show-results-table
        v-if="!!dogInfo && !!showResults && showResults.data && showResults.data.length > 0"
        :results="showResults.data"
        :dog-id="dogId"
      />
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import CoownersList, { OwnershipType } from "@/components/common/CoownersList.vue";
import ReportViewer from "@/components/Admin/Reports/ReportViewer.vue";
import ShowResultsTable from "@/components/Portal/ShowResultsTable.vue";
import dogService from "@/services/dogService";
import { UserInfo } from "@/types/User";

const defaultImage = require('@/assets/photouploadblue-small.png');

export default Vue.extend({
  name: "DogInfo",
  components: {
    CoownersList,
    ReportViewer,
    ShowResultsTable
  },
  data: function () {
    return {
      defaultImage,
      dogInfo: {},
      showResults: {} as any,
      leases: [] as any[],
      showLeasesDialog: false,
      selectedTitle: "",
      Report_Name: 'Asca.Api.Reports.rpt8110_Title_Certificate.rdlx',
      Report_URL: '`/Admin/reports/certificate/${selectedTitle}`',
      showReportDialog: false,
      showReportDialogFull: false,
      showPedigreeDialog: false,
      showPedigreeSmallDialog: false,
      showRegCardDialog: false,
    };
  },
  
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
    dogOwnershipType: function () {
      return OwnershipType.Dog;
    },
    leaseOwnershipType: function () {
      return OwnershipType.Lease;
    },
  },
  methods: {
    showPedigreeReport: function (){
      this.Report_Name = "Asca.Api.Reports.rpt3240_Dog_Pedigree_Report_New2.rdlx";
      this.Report_URL = `/reports/pedigree/${encodeURIComponent(this.dogId?.trim())}`;
      this.showReportDialog = true;
    },
    showRegCard: function (){
      this.Report_Name = "Asca.Api.Reports.rpt3210_Dog_Reg_Certificate.rdlx";
      this.Report_URL = `/reports/registration/${encodeURIComponent(this.dogId?.trim())}`;
      this.showReportDialog = true;
    },
    showTitle: function (title: any){
      (title.isSuffix && !(title.title.includes('DNA'))) ? this.Report_Name= 'Asca.Api.Reports.rpt8110_Title_Certificate.rdlx' : this.Report_Name= 'Asca.Api.Reports.rpt8111_Title_Certificate_Full.rdlx';
      this.selectedTitle = title.certificateId;
      this.Report_URL = '/Admin/reports/certificate/'+this.selectedTitle
      this.showReportDialog = true;
    },
    
  },
  created: function () {
    if (this.dogId && this.userInfo) {
      dogService
        .getDogById(this.dogId, this.userInfo.personId)
        .then((res) => {
          this.dogInfo = res;
        })
        .catch(this.$handleError);
      dogService
        .getDogShowResultsById(this.dogId, this.userInfo.personId)
        .then((res) => {
          this.showResults = res;
        })
        .catch(this.$handleError);
      dogService
        .getDogLeases(this.dogId)
        .then((res) => {
          this.leases = res.data;
        })
        .catch(this.$handleError);
    }
  },
  watch: {
    dogId: function (newVal: String) {
      dogService
        .getDogById(this.dogId, this.userInfo.personId)
        .then((res) => {
          this.dogInfo = res;
        })
        .catch(this.$handleError);
      dogService
        .getDogShowResultsById(this.dogId, this.userInfo.personId)
        .then((res) => {
          this.showResults = res;
        })
        .catch(this.$handleError);
      dogService
        .getDogLeases(this.dogId)
        .then((res) => {
          this.leases = res.data;
        })
        .catch(this.$handleError);
    },
    userInfo: function (newVal: object) {
      dogService
        .getDogById(this.dogId, this.userInfo.personId)
        .then((res) => {
          this.dogInfo = res;
        })
        .catch(this.$handleError);
      dogService
        .getDogShowResultsById(this.dogId, this.userInfo.personId)
        .then((res) => {
          this.showResults = res;
        })
        .catch(this.$handleError);
      dogService
        .getDogLeases(this.dogId)
        .then((res) => {
          this.leases = res.data;
        })
        .catch(this.$handleError);
    },
    
  },
  props: {
    dogId: { type: String },
  },
});
</script>
